import { render, staticRenderFns } from "./annuaire-assurances.vue?vue&type=template&id=62c60112&scoped=true"
import script from "./annuaire-assurances.vue?vue&type=script&lang=js"
export * from "./annuaire-assurances.vue?vue&type=script&lang=js"
import style0 from "./annuaire-assurances.vue?vue&type=style&index=0&id=62c60112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c60112",
  null
  
)

export default component.exports